import { Box, ListItem, Text } from '@domain-group/suit-theme'

import type { EntitiesState } from '@redux/entities'

interface ProviderProps {
  permittedProviderIds: number[],
  providers: EntitiesState['providers'],
}

const Provider = (props: ProviderProps) => {
  const { permittedProviderIds, providers } = props

  return (
    <Box flexDirection="column">
      <ListItem
        boxProps={{ borderTop: '1px dashed', paddingTop: 'medium' }}
        disableHover
      >
        <Text fontSize="small" variant="ellipsis">
          {permittedProviderIds.length ? 'Provided by:' : 'Not available for any providers'}
        </Text>

        <Box flexDirection="column" flex="1" textAlign="right">
          {permittedProviderIds.map((providerId) => {
            const provider = providers[providerId] || {}

            return provider.id && (
              <Text
                color="mysteryGrey"
                fontSize="small"
                key={providerId}
                marginBottom="medium"
                variant="ellipsis"
              >
                {provider.title}
              </Text>
            )
          })}
        </Box>
      </ListItem>
    </Box>
  )
}

export default Provider
